var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "settings-summary-items-v3" }, [
    _c(
      "h4",
      {
        staticClass:
          "typographies-paragraph-large-semibold settings-summary-items-v3__subtitle"
      },
      [
        _vm._v(
          "\n        " +
            _vm._s(_vm.licensesNumber) +
            "\n        " +
            _vm._s(
              _vm.$l10n.n__("utilisateur", "utilisateurs", _vm.licensesNumber)
            ) +
            "\n    "
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "settings-summary-items-v3-listing" },
      _vm._l(_vm.listLicences, function(item, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass:
              "settings-summary-items-v3-listing__item typographies-paragraph-medium-regular"
          },
          [
            _c(
              "div",
              { staticClass: "settings-summary-items-v3-listing__item-label" },
              [
                _c("span", [
                  item.quantity > 1
                    ? _c("span", [_vm._v(_vm._s(item.quantity))])
                    : _vm._e(),
                  _vm._v(
                    "\n                    " +
                      _vm._s(item.label) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _vm.hasTag(item)
                  ? _c("ChargebeeUpsellTag", {
                      attrs: {
                        quantity: item.updatedQuantity,
                        label: _vm.tagLabel(item),
                        "show-quantity": !_vm.isOption(item)
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "upsell-summary-v3-items-listing__item-price" },
              [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$filters.numberFormatCurrency(
                            _vm.humanizeCentsPrice(item.amount)
                          )
                        ) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                item.recurrence
                  ? _c(
                      "span",
                      { staticClass: "typographies-paragraph-small-regular" },
                      [
                        _vm._v(
                          "\n                    /" +
                            _vm._s(_vm.recurrence(item.recurrence)) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "h4",
      {
        staticClass:
          "typographies-paragraph-large-semibold settings-summary-items-v3__subtitle"
      },
      [_vm._v("\n        " + _vm._s(_vm.$l10n.__("Options")) + "\n    ")]
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "settings-summary-items-v3-listing" },
      _vm._l(_vm.listOptions, function(item, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass:
              "settings-summary-items-v3-listing__item typographies-paragraph-medium-regular"
          },
          [
            _c(
              "div",
              { staticClass: "settings-summary-items-v3-listing__item-label" },
              [
                _c("span", [
                  item.quantity > 1
                    ? _c("span", [_vm._v(_vm._s(item.quantity))])
                    : _vm._e(),
                  _vm._v(
                    "\n                    " +
                      _vm._s(item.label) +
                      "\n                "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "settings-summary-items-v3-listing__item-price" },
              [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$filters.numberFormatCurrency(
                            _vm.humanizeCentsPrice(item.amount)
                          )
                        ) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                item.recurrence
                  ? _c(
                      "span",
                      { staticClass: "typographies-paragraph-small-regular" },
                      [
                        _vm._v(
                          "\n                    /" +
                            _vm._s(_vm.recurrence(item.recurrence)) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }